/*
Sohel 04/04/2023 2699762545 Letter Group Make multiSelect dropdown Changes
Sohel 04/08/2023 2699762545 Letter Batch Added Letter Type
Guru Prasad 04/11/2023 2699762545 Fixed spacing issues
Akhila 04/13/2023 2699762545 Added warning popup message
Akhila 04/19/2023 2699762545 bug fixed reset issue in letter group field
*/
import React, {useEffect, useContext} from 'react';
import {Formik} from 'formik';
import {Button, Checkbox, Grid} from '@material-ui/core';
import ErrorBoundaryForComponents from '../../../util/ErrorBoundaryForComponents';
import {useDispatch, useSelector} from 'react-redux';
import PageLoader from '../../../components/PageLoader';
import {ThemeContext} from '../../../themes/ThemeProvider';
// import { ErrorSnackbar, SuccessSnackbar } from "../../../../components/CustomSnackBar";
import {FormHelperText} from '@material-ui/core';
import {
  resetStatus,
  letterRequestExecuteBatch,
} from '../../../redux/reducers/LetterBatches';
import * as Yup from 'yup';
import GuiAutoComplete from '../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../components/FormComponents/GuiTextField';
import {
  fetchAllLetterGroupCode,
  getDropDownData,
} from '../../../redux/reducers/LetterMaintainance/NewLetterMaintenance';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import {LETTER_TYPE} from '../../../constants/Lookup';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const ExecuteForm = ({handleClose, setValue}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();

  const initialValues = {
    letterGroupCode: '',
    letterType: '',
  };

  const {successMsg, isLoading, errorMsg, executeBatchStatus} = useSelector(
    ({letterBatches}) => letterBatches,
  );
  const {allLetterGroupCode, dropDownData} = useSelector(
    ({newLetterMaintenance}) => newLetterMaintenance,
  );
  const getOptions = (typeCode) => {
    let label = [];
    label = dropDownData && dropDownData[typeCode] ? dropDownData[typeCode] : [];
    return label;
  };
  useEffect(() => {
    dispatch(getDropDownData());
  }, []);

  const schema = Yup.object().shape({
    letterGroupCode: Yup.array().test('letterGroup', 'Letter Group is required', (val) => {
      if (val?.length) {
        return true;
      } else {
        return false;
      }
    }),
    letterType: Yup.mixed().test('LetterType', 'Letter Type  is required', (value) => {
      if (!value?.value) {
        return false;
      } else {
        return true;
      }
    }),
  });

  const handleSubmit = (data) => {
    const groupCode =
      data?.letterGroupCode?.length > 0 ?
        data?.letterGroupCode?.map((el) => el.letterGroupCode) :
        [];
    if (data) {
      dispatch(
        letterRequestExecuteBatch({
          groupCodes: groupCode,
        }),
      );
    }
  };

  // useEffect(() => {
  //   dispatch(getLetterGroupDropDownData());
  // }, []);

  useEffect(() => {
    if (executeBatchStatus === 200) {
      handleClose();
      setValue(0);
      setTimeout(() => {
        dispatch(resetStatus());
      }, 2500);
    }
  }, [executeBatchStatus]);

  useEffect(() => {
    if (successMsg || errorMsg || isLoading) {
      setTimeout(() => {
        dispatch(resetStatus());
      }, 4000);
    }
  }, [successMsg, errorMsg, isLoading]);

  return (
    <div className={classes.dialoguecardStyles}>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialValues}
        validationSchema={schema}
        enableReinitialize
      >
        {(props) => {
          const {
            values,
            touched,
            errors,
            handleSubmit,
            handleReset,
            setFieldValue,
          } = props;
          return (
            <div className="standard-field-textfields new-standard-textfields">
              <form autoComplete="off" noValidate onSubmit={handleSubmit} onReset={handleReset}>
                <div>
                  <ErrorBoundaryForComponents>
                    <Grid container spacing={2}>
                      <>
                        <Grid item xs={6} md={6} className="form-group">
                          <GuiAutoComplete
                            classes={{
                              option: classes.option,
                            }}
                            name="letterType"
                            id="letterType"
                            size="small"
                            value={values.letterType}
                            options={
                              getOptions(LETTER_TYPE).length > 0 ? getOptions(LETTER_TYPE) : []
                            }
                            getOptionLabel={(option) => {
                              return option?.value ? option?.value : '';
                            }}
                            onChange={(e, value) => {
                              setFieldValue('letterType', value);
                              if (value?.valueCode) {
                                setFieldValue('letterGroupCode', '');
                                dispatch(fetchAllLetterGroupCode(value?.valueCode));
                              }
                            }}
                            renderInput={(params) => (
                              <div className="select-field">
                                <GuiTextField
                                  {...params}
                                  variant="outlined"
                                  className={` ${classes.labelName}`}
                                  touched={touched.letterType}
                                  error={touched.letterType && errors.letterType}
                                  margin="dense"
                                  required
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  label="Letter Type"
                                  placeholder="Select Letter Type"
                                />
                              </div>
                            )}
                          />
                          <FormHelperText style={{color: 'red'}}>
                            {touched.letterType && errors?.letterType && errors.letterType}
                          </FormHelperText>
                        </Grid>
                        <Grid item xs={6} md={6} className="form-group">
                          <GuiAutoComplete
                            name={'letterGroupCode'}
                            id={'letterGroupCode'}
                            size="small"
                            limitTags={1}
                            classes={{
                              option: classes.option,
                              listbox: classes.listBox,
                            }}
                            disableCloseOnSelect
                            getOptionSelected={(option, value) =>
                              option?.letterGroupCode === value?.letterGroupCode
                            }
                            value={
                              values?.letterGroupCode?.length > 0 ? values?.letterGroupCode : []
                            }
                            disabled={!values?.letterType?.valueCode}
                            multiple
                            onChange={(e, value) => {
                              setFieldValue('letterGroupCode', value);
                            }}
                            options={allLetterGroupCode || []}
                            autoHighlight
                            renderOption={(option, {selected}) => {
                              return (
                                <React.Fragment>
                                  <>
                                    <Checkbox
                                      icon={icon}
                                      checkedIcon={
                                        <CheckBoxIcon fontSize="small" className="selectcheckBox" />
                                      }
                                      checked={selected}
                                    />
                                  </>
                                  {option?.letterGroupCode} - {option?.letterGroupDescription}
                                </React.Fragment>
                              );
                            }}
                            getOptionLabel={(option) => {
                              return option?.letterGroupCode ?
                                option?.letterGroupCode + ' -' + option?.letterGroupDescription :
                                '';
                            }}
                            renderInput={(params) => (
                              <div className="select-field">
                                <GuiTextField
                                  {...params}
                                  variant="outlined"
                                  className={`autocomplete-multiselect-label ${classes.labelName}`}
                                  margin="dense"
                                  required
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  error={touched?.letterGroupCode && errors?.letterGroupCode}
                                  label={'Letter Group'}
                                  placeholder={`Select Letter Group`}
                                  inputProps={{
                                    ...params.inputProps,
                                    autoComplete: 'off',
                                  }}
                                />
                              </div>
                            )}
                          />
                          <FormHelperText style={{color: 'red'}}>
                            {touched?.letterGroupCode &&
                              errors.letterGroupCode &&
                              errors.letterGroupCode}
                          </FormHelperText>
                        </Grid>
                      </>
                    </Grid>
                  </ErrorBoundaryForComponents>
                </div>
                <div className="d-flex justify-content-center align-items-center">
                  <Button
                    variant="outlined"
                    className={`reset-btn mr-1 ${classes.buttonRoot}`}
                    onClick={() => {
                      handleReset();
                    }}
                  >
                    Clear
                  </Button>
                  <Button
                    variant="outlined"
                    type="submit"
                    className={`search-btn ml-1 mr-1 ${classes.buttonRoot}`}
                  >
                    Execute
                  </Button>
                </div>
              </form>
            </div>
          );
        }}
      </Formik>
      {isLoading && <PageLoader />}
      {/* {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />} */}
    </div>
  );
};

export default ExecuteForm;
